export const BANNER_HEIGHT = 33;
